<template>
  <div>
    <input
      id="phone_number"
      ref="phoneInput"
      type="tel"
      :class="inputClass"
      @input="$emit('input')"
    />
  </div>
</template>

<script>
import intlTelInput from "intl-tel-input/intlTelInputWithUtils";
import "intl-tel-input/build/css/intlTelInput.css";

export default {
  name: "PhoneInput",
  props: {
    inputClass: { type: String, default: "" },
    hiddenInputName: { type: String, default: "phone_number" },
    initialValue: { type: String, default: "" }
  },
  data() {
    return { iti: null };
  },
  mounted() {
    this.iti = intlTelInput(this.$refs.phoneInput, {
      initialCountry: "auto",
      geoIpLookup: callback => {
        fetch("https://ipapi.co/json/")
          .then(r => r.json())
          .then(data => callback(data.country_code?.toLowerCase() || "mx"))
          .catch(() => callback("mx"));
      },
      countryOrder: ["mx", "us", "co", "gt", "sv", "hn", "ni", "cr", "pa"],
      separateDialCode: true,
      countrySearch: true,
      formatOnDisplay: true,
      strictMode: true,
      validationNumberType: "MOBILE",
      hiddenInput: () => ({
        phone: this.hiddenInputName
      })
    });

    if (this.initialValue) {
      this.iti.setNumber(this.initialValue);
    }
  },
  beforeUnmount() {
    if (this.iti) {
      this.iti.destroy();
    }
  },
  methods: {
    isValidMobileNumber() {
      return this.iti ? this.iti.isValidNumber() : false;
    },
    focus() {
      this.$refs.phoneInput.focus();
    }
  }
};
</script>

<style>
.iti {
  width: 100%;
}
</style>
